export enum TutorialType {
    DNA_TEST = "dna-test",
    CONSULT = "consult",
    SUB_HEALTH = "sub-health",
    SUB_NUTRITION = "sub-nutrition",
}